/**
 * Melian Dialogue — landing page brand tokens.
 * Single source of truth for hex + rgba variants. All landing-page inline styles
 * MUST funnel through this file to guarantee palette consistency.
 */

// Solid brand hexes
export const BRAND         = "var(--brand-green-fg, #006600)"; // adaptive: #006600 light, #4ADE80 dark
export const BRAND_SOLID   = "#006600";     // Use for surfaces (button bg, chip bg) — not text on dark.
export const BRAND_HOVER   = "#004d00";     // darker green on hover
export const BRAND_RED     = "var(--brand-red-fg, #922529)"; // adaptive for dark mode (WCAG-AA)
export const BRAND_RED_SOLID = "#922529";   // Use only for surfaces (buttons, chips, monograms)

// Green transparent variants — use for inline rgba(background|border|shadow)
export const BRAND_06      = "rgba(0,102,0,0.06)";
export const BRAND_08      = "rgba(0,102,0,0.08)";
export const BRAND_10      = "rgba(0,102,0,0.10)";
export const BRAND_15      = "rgba(0,102,0,0.15)";
export const BRAND_25      = "rgba(0,102,0,0.25)";
export const BRAND_33      = "rgba(0,102,0,0.33)";
export const BRAND_55      = "rgba(0,102,0,0.55)";

// Red transparent variants (rarely used but ready)
export const BRAND_RED_10  = "rgba(146,37,41,0.10)";
export const BRAND_RED_20  = "rgba(146,37,41,0.20)";
export const BRAND_RED_33  = "rgba(146,37,41,0.33)";

// Convenience Tailwind class factories (theme-bound)
export const paletteClasses = (isDark) => ({
    shell:            isDark ? "bg-[#0A0A0A] text-white"            : "bg-white text-slate-900",
    headerBg:         isDark ? "border-zinc-800 bg-[#0A0A0A]/80"    : "border-slate-200 bg-white/80",
    subtleText:       isDark ? "text-zinc-400"                      : "text-slate-600",
    faintText:        isDark ? "text-zinc-500"                      : "text-slate-400",
    cardBg:           isDark ? "bg-[#141414] border-zinc-800"       : "bg-white border-slate-200 shadow-sm",
    cardHoverBorder:  isDark ? "hover:border-zinc-700"              : "hover:border-slate-300",
    divider:          isDark ? "border-zinc-900"                    : "border-slate-200",
    outlineBtn:       isDark ? "border-zinc-800 hover:bg-zinc-900 text-white"
                             : "border-slate-200 hover:bg-slate-100 text-slate-700",
    outlineIcon:      isDark ? "border-zinc-800 bg-zinc-900 text-zinc-400 hover:text-white"
                             : "border-slate-200 bg-white text-slate-600 hover:text-slate-900",
    listDivider:      isDark ? "border-zinc-800/60"                 : "border-slate-100",
    strikeText:       isDark ? "text-zinc-500"                      : "text-slate-400",
    shotFrame:        isDark
        ? "border border-zinc-800 shadow-[0_20px_80px_-20px_rgba(146,37,41,0.35)]"
        : "border border-slate-200 shadow-2xl",
});
